/* eslint-disable no-undef */
/* eslint-disable no-unused-vars  */

import 'jquery';
import './slick/slick.min.js';

//activating animations
document.addEventListener('DOMContentLoaded', function() {
  var body = document.querySelector('body');
  body.classList.remove('preload');
});


$(function() {

  $(window).scroll(function() {

    var scrollTop     = $(window).scrollTop(),
    elementOffset = $('.banner2__img-wrap').offset().top,
    distance      = (elementOffset - scrollTop);

    if(distance < 50) {
      $('.banner2__img-wrap').addClass('animate');
    } else {
      $('.banner2__img-wrap').removeClass('animate');
    }
  });




  $('.slider').slick({
    autoplay: true,
    autoplaySpeed: 1500,
    mobileFirst: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    speed: 1000,
    centerMode: true,
    variableWidth: false,
    arrows: true,
    prevArrow: $('.member-prev'),
    nextArrow: $('.member-next'),
    swipeToSlide: true,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 6,
        },
      },
      {
        breakpoint: 1919,
        settings: {
          slidesToShow: 8,
          slidesToScroll: 6,
        },
      },
    ],
  });
  $('.slider').slick('slickSetOption', 'slidesToScroll', 6, true);

  $(document).on('click','[data-toggle-nav]', function() {
    $('.mobile-nav').toggleClass('mobile-nav--open');
    $('.hamburger').toggleClass('hamburger--open');

    // if($('.mobile-nav').hasClass('mobile-nav--open')) {
    //   prevent_scroll();
    // } else {
    //   allow_scroll();
    // }
  });


  function close_nav() {
    $('.mobile-nav').removeClass('mobile-nav--open');
    $('.hamburger').removeClass('hamburger--open');
    //allow_scroll();
  }

  $('a[href*="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr('href');
    href = href.substring(href.indexOf('#'));
    var target = $(href == '#' || href == '' ? 'html' : href);
    var position = target.offset().top - $('.header').height();

    close_nav();

    $('html, body').animate({scrollTop:position}, speed, 'swing');
    return false;
  });

});



// WEBPACK FOOTER //
// ./scripts/main.js